import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Flow2"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M12.0005 2.75C16.6832 2.75 20.5532 6.22958 21.166 10.7442L19.0025 9.66253L18.3317 11.0042L21.6651 12.6708C21.8976 12.7871 22.1737 12.7746 22.3948 12.638C22.6159 12.5013 22.7505 12.2599 22.7505 12C22.7505 6.06294 17.9376 1.25 12.0005 1.25V2.75Z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.85679 2.67676C4.54903 2.67676 2.67822 4.54757 2.67822 6.85533C2.67822 9.16309 4.54903 11.0339 6.85679 11.0339C9.16455 11.0339 11.0354 9.16309 11.0354 6.85533C11.0354 4.54757 9.16455 2.67676 6.85679 2.67676ZM4.17822 6.85533C4.17822 5.37599 5.37746 4.17676 6.85679 4.17676C8.33613 4.17676 9.53536 5.37599 9.53536 6.85533C9.53536 8.33466 8.33613 9.5339 6.85679 9.5339C5.37746 9.5339 4.17822 8.33466 4.17822 6.85533Z"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M17.1429 12.9629C14.8352 12.9629 12.9644 14.8337 12.9644 17.1415C12.9644 19.4492 14.8352 21.32 17.1429 21.32C19.4507 21.32 21.3215 19.4492 21.3215 17.1415C21.3215 14.8337 19.4507 12.9629 17.1429 12.9629ZM14.4644 17.1415C14.4644 15.6621 15.6636 14.4629 17.1429 14.4629C18.6223 14.4629 19.8215 15.6621 19.8215 17.1415C19.8215 18.6208 18.6223 19.82 17.1429 19.82C15.6636 19.82 14.4644 18.6208 14.4644 17.1415Z"
}, null, -1);
const _hoisted_5 = /* @__PURE__ */ _createElementVNode("path", { d: "M1.6057 11.361C1.82681 11.2244 2.10292 11.212 2.33541 11.3282L5.66872 12.9949L4.9979 14.3365L2.83453 13.2548C3.4473 17.7694 7.31731 21.249 12 21.249V22.749C6.06295 22.749 1.25 17.9361 1.25 11.999C1.25 11.7391 1.38459 11.4977 1.6057 11.361Z" }, null, -1);
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Flow2.vue"]]);
